import { render, staticRenderFns } from "./CleanPassword.vue?vue&type=template&id=23a4c0f9&scoped=true"
import script from "./CleanPassword.vue?vue&type=script&lang=js"
export * from "./CleanPassword.vue?vue&type=script&lang=js"
import style0 from "./CleanPassword.vue?vue&type=style&index=0&id=23a4c0f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a4c0f9",
  null
  
)

export default component.exports